import type { SvgIconProps } from "@mui/material/SvgIcon";
import { type FC, useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { ChartViewEnum } from "~/feature/chart/types";
import { isConsensusAvailable } from "~/feature/chart/utils";
import type { IOption } from "~/types/option";

import {
  CONSENSUS_UNAVAILABLE_TOOLTIP,
  iconByChartViewEnum,
  labelByChartViewEnum,
} from "./constants";

export interface IChartViewModeOption extends Omit<
  IOption<ChartViewEnum>,
  "icon"
> {
  icon?: FC<SvgIconProps>;
  disabledTooltip?: string;
}

export const useChartViewModeOptions = (): IChartViewModeOption[] => {
  const { markets, selections } = useCoreChart();

  const isConsensusDisabled = useMemo(
    () => !isConsensusAvailable(markets, selections),
    [markets, selections]
  );

  return useMemo(
    () =>
      Object.values(ChartViewEnum).map(
        (value): IChartViewModeOption => ({
          value,
          label: labelByChartViewEnum[value],
          icon: iconByChartViewEnum[value],
          disabledTooltip:
            value === ChartViewEnum.CONSENSUS && isConsensusDisabled
              ? CONSENSUS_UNAVAILABLE_TOOLTIP
              : undefined,
        })
      ),
    [isConsensusDisabled]
  );
};
